export const RentFrequency = {
  Fortnightly: 1002002,
  Monthly: 1002004,
  ProRata: 1002006,
  Weekly: 1002009
} as const;

export type RentFrequencyType = keyof typeof RentFrequency;
export type RentFrequencyCodes = (typeof RentFrequency)[RentFrequencyType];
